import React, { Component } from 'react';

import {BASE_URL_BOLETIN} from '../../../constants';
import styled from 'styled-components';


export default class DetalleMailingOcer extends Component {

    state = {
        addNoticias: this.props.recurso,
        colorBoletin: this.props.color,
        imageArrow: this.props.imagen,
        titulo: this.props.titulo,
        nBoletinCodigo: this.props.boletin
      }


    render() {
        return (     
            <div>
                <tr>
                    <td style={{background: '#ffffff', padding: '10px 20px'}}>
                        <table>
                            <tbody>
                                <tr hidden={((this.state.addNoticias.length>0)?false:true)}>
                                    <td>
                                        <ul style={{marginLeft: '-19px'}}>
                                            <li>
                                                <h3 style={{ fontSize:'1.8em', textAlign: 'left', fontWeight: 400, marginBottom: '0px', color: '#43434b', marginTop: 0}}>
                                                    { this.state.titulo}
                                                    {/* OPORTUNIDADES INTERNACIONALES */}
                                                </h3>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                                <br/>
                                {this.state.addNoticias.map((resource) => (
                                <span>
                                    <tr>
                                        <td className="img" style={{paddingBottom: '10px'}}>
                                            <table style={{ width:'100%', background: '#d0d3d9', borderLeft: '5px solid ' + this.state.colorBoletin, borderRadius: '5px'}}>
                                                <tbody>
                                                <tr>
                                                    <td>
                                                    <p style={{color: '#43434b', padding: '0px 20px', fontSize: '18px', fontWeight: 'bold', marginBottom: '5px' }}>
                                                        <br/>
                                                        {resource.sTituloRecurso}
                                                    </p>
                                                    <br/>
                                                    <p style={{ fontSize: '14px', color: '#43434b', padding: '0px 20px', marginBottom: '0px', marginTop: '0px', lineHeight: '1.5'}}>
                                                        {resource.sResumenRecurso}
                                                    </p>
                                                    </td>
                                                </tr>
                                                <tr style={{textAlign: 'right'}}>
                                                    <td style={{padding: '0px 0px 10px'}}>
                                                    <table align="right">
                                                        <tbody>
                                                        <tr>
                                                            <td>
                                                            <a target="_blank" href={BASE_URL_BOLETIN + '/' + this.state.nBoletinCodigo + '/' + resource.nRecursoCodigo} style={{fontWeight: 'bold', paddingRight: '2px', color: '#d52b1e'}}>Más info</a>
                                                            </td>
                                                            <td style={{paddingRight: '9px', paddingBottom: '5px'}}>
                                                            <img src={this.state.imageArrow} />
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </span>
                                ))}
                            </tbody>
                        </table>
                    </td>
                </tr>
            </div>
                   )
        ;
    }

}